import { cn, Skeleton } from '@longy/web-components'
import { ImageOff } from 'lucide-react'

import { useFileImage } from '../../hooks/useFileImage'

export const EventImage = ({
    fileId,
    alt,
    className,
}: {
    fileId: string | undefined
    alt: string
    className?: string
}) => {
    const { imageUrl, isLoading } = useFileImage(fileId)

    return (
        <div
            className={cn(
                'flex w-full items-center justify-center overflow-hidden bg-slate-50',
                className,
            )}
        >
            {isLoading ? (
                <Skeleton className="size-full" />
            ) : imageUrl ? (
                <img alt={alt} className="size-full object-contain" src={imageUrl} />
            ) : (
                <ImageOff aria-hidden className="size-10 text-slate-300" />
            )}
        </div>
    )
}
